export default __webpack_public_path__ + "static/media/crown_bronze.ed597ebe.svg";